import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type PageBreadcrumb = {
  label: string;
  to: string;
};

export interface AppLayoutState {
  pageTitle: string | null;
  breadcrumb: PageBreadcrumb | null;
  noTopPaddingCount: number;
}

const initialState: AppLayoutState = {
  pageTitle: null,
  breadcrumb: null,
  noTopPaddingCount: 0,
};

export const appLayoutSlice = createSlice({
  name: "appLayout",
  initialState,
  reducers: {
    setPageTitle: (state, action: PayloadAction<string | null>) => {
      state.pageTitle = action.payload;
    },
    setPageBreadcrumb: (
      state,
      action: PayloadAction<PageBreadcrumb | null>
    ) => {
      state.breadcrumb = action.payload;
    },
    registerNoTopPadding: (state) => {
      state.noTopPaddingCount += 1;
    },
    unregisterNoTopPadding: (state) => {
      state.noTopPaddingCount = Math.max(0, state.noTopPaddingCount - 1);
    },
  },
});

export const {
  setPageTitle,
  setPageBreadcrumb,
  registerNoTopPadding,
  unregisterNoTopPadding,
} = appLayoutSlice.actions;

export default appLayoutSlice.reducer;
